import { $methodKey, METHOD_TEMPLATES } from "../../utils/consts";
/**
 * 通用的状态初始
 * @param this
 * @param params
 */
export const stateInit = async function (params) {
  const {
    assign,
    invoke
  } = params;
  assign.forEach(item => {
    if (typeof item.key === 'string' && item.key.length) {
      this[item.key] = item.value;
    }
  });
  for (const item of invoke) {
    const fn = this[$methodKey][item.method];
    if (typeof fn === 'function') {
      await fn(...(item.args || []));
    }
  }
};
stateInit.template = [METHOD_TEMPLATES.any.init, METHOD_TEMPLATES.form.init, METHOD_TEMPLATES.list.init];
//# sourceMappingURL=init.js.map
